/**
 * Buttons settings to generate atomic classes.
 *
 * WARNING!!! `key` are required.
 * Other are used in iCMS
 */
const button = [
    // default from atomic
    // ...atomic.component,
    // custom local
    { key: 'button', title: 'Primary Dark' },
    { key: 'button-1', title: 'Primary Dark, Outline' },
    { key: 'button-2', title: 'Primary Light', sgClass: 'bg-col-13' },
    { key: 'button-3', title: 'Primary Light, Outline', sgClass: 'bg-col-13' },
    { key: 'button-inline', title: 'Text Button' },
    { key: 'button-inline has-icon', title: 'Text Button - Arrow' },
    { key: 'button-inline button--large has-icon', title: 'Text Button Large - Arrow' },
    { key: 'button-inline button-inline-extra-small', title: 'Small Text Button' },
    { key: 'button-inline-1', title: 'Text Button White', sgClass: 'bg-col-13' },
    { key: 'button-inline-1 has-icon', title: 'Text Button White - Arrow', sgClass: 'bg-col-13' },
    { key: 'button-inline-1 button--large has-icon', title: 'Text Button White Large - Arrow', sgClass: 'bg-col-13' },
    { key: 'button-inline-1 button-inline-extra-small', title: 'Small Text Button White', sgClass: 'bg-col-13' }
];
exports.button = button;
